module.exports = __webpack_public_path__ + "static/media/TPIcon.a89ea89d.png";